export default __webpack_public_path__ + "d8462e51de1f0e5f9d9d9e9e5127c943.svg";